export const BASE_URL = 'https://backend.nuserenitywellness.com/api';

export const WEIGHT_LOSS_EXAM = 'Weight Loss';
export const IV_THERAPY_EXAM = 'IV Therapy';
